<template>
    <div>
        <Breadcrumb section-name="Order" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-header text-center">
                    <h5 class="mt-2">Raw Materials Sales Details Report</h5>
                </div>
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <div class="row">
                        <div class="col-md-10">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2" class="text-center">Raw Materials Purchase Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Product Purchase Date</td>
                                        <th>{{ addEditParam.purchase_date }}</th>
                                    </tr>
                                    <tr>
                                        <td>Purchase By</td>
                                        <th>{{ addEditParam.purchase_by_name }}</th>
                                    </tr>
                                    <tr>
                                        <td>Company Name (Seller)</td>
                                        <th>{{ addEditParam.company_name }}</th>
                                    </tr>
                                    <tr>
                                        <td>Company Address (Seller)</td>
                                        <th>{{ addEditParam.company_address }}</th>
                                    </tr>
                                    <tr>
                                        <td>Company Contract Number (Seller)</td>
                                        <th>{{ addEditParam.company_contact_number }}</th>
                                    </tr>
                                    <tr>
                                        <td>Raw Material Name</td>
                                        <th>{{ addEditParam.raw_material_name }}</th>
                                    </tr>
                                    <tr>
                                        <td>Unit</td>
                                        <th>{{ addEditParam.unit_name }}</th>
                                    </tr>
                                    <tr>
                                        <td>Quantity</td>
                                        <th>{{ addEditParam.quantity }}</th>
                                    </tr>
                                    <tr>
                                        <td>Unit Price</td>
                                        <th>{{ addEditParam.unit_price }}</th>
                                    </tr>
                                    <tr>
                                        <td>Total Price</td>
                                        <th>{{ addEditParam.total_price }}</th>
                                    </tr>
                                    <tr>
                                        <td>Product Description</td>
                                        <th>{{ addEditParam.description }}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-2">
                            <a class="me-2 btn btn-option mb-2 float-end" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="pdf" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-10">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th colspan="2" class="text-center">Raw Materials Selling Details</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Product Sales Date</td>
                                    <th>{{ addEditParam.sales_date }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Name (Buyer)</td>
                                    <th>{{ addEditParam.customer_name }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Address (Buyer)</td>
                                    <th>{{ addEditParam.customer_address }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Contact Number (Buyer)</td>
                                    <th>{{ addEditParam.customer_contact_number }}</th>
                                </tr>
                                <tr>
                                    <td>Company Contract Number (Seller)</td>
                                    <th>{{ addEditParam.company_contact_number }}</th>
                                </tr>
                                <tr>
                                    <td>Sales By</td>
                                    <th>{{ addEditParam.sales_by }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Order Number</td>
                                    <th>{{ addEditParam.order_number }}</th>
                                </tr>
                                <tr>
                                    <td>Quantity</td>
                                    <th>{{ addEditParam.order_date }}</th>
                                </tr>
                                <tr>
                                    <td>Customer Order Date</td>
                                    <th>{{ addEditParam.order_date }}</th>
                                </tr>
                                <tr>
                                    <td>Selling Price</td>
                                    <th>{{ addEditParam.selling_price }}</th>
                                </tr>
                                <tr>
                                    <td>Profit Amount</td>
                                    <th>{{ addEditParam.profit }}</th>
                                </tr>
                                <tr>
                                    <td>Profit Deposit</td>
                                    <th>{{ addEditParam.profit_deposit }}</th>
                                </tr>
                                <tr>
                                    <td>Profit Deposit By</td>
                                    <th>{{ addEditParam.profit_deposit_by }}</th>
                                </tr>
                                <tr>
                                    <td>Profit Deposit Date</td>
                                    <th>{{ addEditParam.profit_deposit_date }}</th>
                                </tr>
                                <tr>
                                    <td>Remarks</td>
                                    <th>{{ addEditParam.remarks }}</th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import Table from "../Common/Table.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    name: "Purchase Order",
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Challan'],
            loading: false,
            dataLoading: false,
            addEditParam: {

            },
            rawMaterials: [],
            exportLoading: false,
        }
    },
    methods: {
        downloadFile: function () {
            this.exportLoading = true;
            let route = ApiRoutes.Purchase  + '/export'
            let name = 'purchase.pdf'
            ApiService.DOWNLOAD(route, {id: this.$route.params.id},'',res => {
                this.exportLoading = false;
                let blob = new Blob([res], {type: 'application/pdf'});
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = name;
                link.click();
            });
        },
        fetchSinglePurchase: function() {
            ApiService.POST(ApiRoutes.Purchase + '/single', {id: this.$route.params.id}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data;
                }
            });
        },
    },
    mounted() {
        this.fetchSinglePurchase();
    }
}
</script>
<style scoped>

</style>
